/**
 * SectionGate — Renders children based on the resolved section access:
 *   'hidden' → renders nothing (and the section is also dropped from nav
 *              upstream via the same resolution).
 *   'public' → renders children as-is.
 *   'authed' → signed-in viewers see the content; non-authed viewers see
 *              nothing at all. Earlier this rendered a GateBlock teaser
 *              with a "Kirjaudu" prompt, but the curator's intent is to
 *              hide *what they're missing*: a teaser advertised the gated
 *              content's existence. The top-bar Kirjaudu pill is still
 *              the way in.
 *
 * Pass `access` directly so callers can do the resolution once and
 * combine with their own data-availability guards (e.g. don't render
 * Vipupisteet when there are zero pivot points).
 */
import React from 'react';
import { ACCESS_HIDDEN, ACCESS_AUTHED } from './sectionAccess';
import { useReportAuth } from './ReportAuthContext';

export default function SectionGate({ access, children }) {
  const { isAuthed } = useReportAuth();
  if (access === ACCESS_HIDDEN) return null;
  if (access === ACCESS_AUTHED && !isAuthed) return null;
  return children;
}
